import React, { useState } from "react";
import { CheckImageType } from "../../enums/check";
type CameraScreenProps = {
  type?: CheckImageType;
  refEl?: any;
  id?: string;
  handleCapture?: any;
};

export const PaymentFlowPaymentMethodMobileCheckPaymentCameraWeb = (props: CameraScreenProps) => {
  const { type, refEl, id, handleCapture } = props;
  const [capturing, setCapturing] = useState(false);

  return (
    <input
      id={id}
      disabled={capturing}
      ref={refEl}
      type="file"
      accept="image/*"
      capture
      onChange={handleCapture(type)}
      style={{ display: "none" }}
    />
  );
};
